var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logNewParams.length>0)?_c('log-new',{attrs:{"params":_vm.logNewParams}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }